import Vue from 'vue';

Vue.component('renting-option-car-component', {
    props: {
        models: {
            type: Array,
        },
        pageContent: {
            type: Object,
        },
    },

    data() {
        return {
            selectedCar: null,
            selectedArvalCarDescription: '',
            selectedCarModelRentingPageUrl: '',
            apiCarPrices: undefined,
            calculatedPriceFromApi: 0.0,
            calculatedPriceFromApiDisplay: '',
            isApiLoading: false,
            activeTooltipId: null,
        };
    },

    watch: {
        apiCarPrices: {
            deep: true,
            handler(newValue) {
                if (!newValue) return;
                this.calculatedPriceFromApi = newValue.find(
                    (apiCarPrice) =>
                        apiCarPrice.carManufacturerCode ===
                        this.selectedCar.carManufacturerCode,
                ).apiCarPrice;
            },
        },
    },

    computed: {
        isCarSelected() {
            return this.selectedCar !== null
                ? ''
                : 'renting-option__button--disabled';
        },

        isTooltipVisible(carId) {
            return this.activeTooltipId === carId
                ? 'renting-options__models__tooltip-text--active'
                : '';
        },
    },

    mounted() {
        // Add event listener for handling clicks outside tooltip
        window.addEventListener('click', this.handleOnElementOutsideClick);
    },

    destroyed() {
        // Remove event listener when component is destroyed
        window.removeEventListener('click', this.handleOnElementOutsideClick);
    },

    methods: {
        togglePriceTooltip(event, carId) {
            // Stop event propagation to prevent parent button click
            if (event) {
                event.stopPropagation();
            }

            // If the clicked tooltip is already active, close it, otherwise set it as active
            this.activeTooltipId =
                this.activeTooltipId === carId ? null : carId;
        },

        closePriceTooltip() {
            this.activeTooltipId = null;
        },

        handleOnElementOutsideClick(event) {
            this.handleTooltipOutsideClick(
                '.renting-options__models__tooltip-wrapper',
                event,
                this.closePriceTooltip,
            );
        },

        handleTooltipOutsideClick(className, event, callback) {
            const tooltip = document.querySelector(className);
            if (!tooltip) return;

            const isClickInsideTooltip = tooltip.contains(event.target);
            if (!isClickInsideTooltip) {
                callback();
            }
        },

        toggleSelectedCar(carManufacturerCode) {
            if (!this.selectedCar) return '';
            return this.selectedCar.carManufacturerCode === carManufacturerCode
                ? 'renting-option__models__image-container--selected'
                : '';
        },

        showCarPrice(carModel, carPrice) {
            const decodedCarModel = JSON.parse(carModel);
            if (!this.apiCarPrices) return carPrice;
            const foundPrice = this.apiCarPrices.find(
                (apiCarPrice) =>
                    apiCarPrice.carManufacturerCode ===
                    decodedCarModel.carManufacturerCode,
            ).apiCarPrice;
            return foundPrice;
        },

        selectCar(e, carManufacturerCode, arvalDescription) {
            const foundCar = this.models.find(
                (model) => model.carManufacturerCode === carManufacturerCode,
            );

            this.selectedCar = foundCar;
            this.selectedCarModelRentingPageUrl = `${window.location.pathname}/${foundCar.modelSlug}`;
            this.selectedArvalCarDescription = arvalDescription;
            this.calculatedPriceFromApi = e.currentTarget.dataset.apiCarPrice;
            this.calculatedPriceFromApiDisplay = this.calculatedPriceFromApi
                ? this.calculatedPriceFromApi.toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                  })
                : '0,00';
        },
    },
});
